var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorRound9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_20843)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#7FADD1"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_412_20843)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#7FADD1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 36,
    height: 34.5,
    rx: 6,
    fill: "url(#paint0_linear_412_20843)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 34.5,
    width: 36,
    height: 1.5,
    rx: 0.75,
    fill: "url(#paint1_linear_412_20843)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_412_20843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3221 14.1001C14.9221 16.7001 15.6387 18.0001 17.4721 18.0001C18.3387 18.0001 19.1221 17.6168 19.8221 16.8501C20.2554 15.5501 20.4721 14.5335 20.4721 13.8001C20.6721 12.5001 20.5887 11.4835 20.2221 10.7501C19.8554 9.98348 19.2721 9.60015 18.4721 9.60015C16.7721 9.60015 15.7221 11.1001 15.3221 14.1001ZM18.6221 20.4001C17.5887 20.8335 16.5887 21.0501 15.6221 21.0501C14.6887 21.0501 13.8887 20.9001 13.2221 20.6001C12.5554 20.2668 12.0054 19.8168 11.5721 19.2501C10.6721 18.1168 10.3387 16.4835 10.5721 14.3501C10.9387 11.7501 11.9554 9.71681 13.6221 8.25015C15.1887 6.85015 17.0054 6.15015 19.0721 6.15015C21.2387 6.15015 22.8721 6.85015 23.9721 8.25015C25.1387 9.81681 25.5054 12.1168 25.0721 15.1501C24.5721 18.9501 23.0887 22.1501 20.6221 24.7501C18.4887 27.0168 15.8221 28.7335 12.6221 29.9001L11.6721 26.6001C14.8387 25.3668 17.1554 23.3001 18.6221 20.4001Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_412_20843",
    x: 10.5,
    y: 6.15015,
    width: 14.748,
    height: 24.6867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.936664
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_412_20843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_412_20843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_20843",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_20843",
    x1: 0,
    y1: 35.25,
    x2: 36,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517013,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_20843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_412_20843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorRound9);
export default __webpack_public_path__ + "static/media/motor_round_9.9ff274e00260b41bfd9404775ee77208.svg";
export { ForwardRef as ReactComponent };